import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const MyTasks = () => {
  const { mode } = useTheme();
  const isDark = mode === 'dark';

  return (
    <div className={`flex-1 flex flex-col overflow-y-auto ${
      isDark ? 'bg-[#0a0a0a]' : 'bg-white'
    }`}>
      <div className="max-w-4xl mx-auto w-full px-8 py-20 flex flex-col items-center text-center">
        <h1 className={`text-[3.5rem] font-black tracking-tight mb-6 leading-tight ${
          isDark ? '!text-white' : 'text-[#0f172a]'
        }`}>
          Tasks
        </h1>
        <p className={`text-lg font-medium max-w-2xl leading-relaxed ${
          isDark ? 'text-white/60' : 'text-slate-400'
        }`}>
          TeamGrid Tasks is not enabled for this organisation yet.
        </p>
      </div>
    </div>
  );
};

export default MyTasks;
